import { Injectable } from '@angular/core';
import { DSRESTClient } from '../shared/communication-objects/restclient.service';
import { Observable, map, of } from 'rxjs';
import { Cacheable } from 'ts-cacheable';
import { GeneralUtilities } from '../utilities/generaleUtilities';



@Injectable({ providedIn: 'root' })
export class StringResourceService {
  constructor(private restClient: DSRESTClient) {}

  @Cacheable()
  GetLocalizedGrid(groupName): Observable<any> {
    //return of(null);
    //console.log("===================================== GetLocalizedGrid")
    return this.restClient
      .get(`StringResource/GetLocalizedGrid/${groupName}`)
      .pipe(
        //convert lower case property names to Upper case
        map((data) => GeneralUtilities.toUpperCase(data))
      );
  }

  GroupLocalizedResources(groups): Observable<any> {
    //return of(null);
    //console.log("===================================== GroupLocalizedResources", groups)
    return this.restClient
      .post(`StringResource/GetLocalizedResourceGroups/`, groups)
      .pipe(
        //convert lower case property names to Upper case
        map((data) => GeneralUtilities.toUpperCase(data))
      );
  }

  GetLocalizedResourceGroups(groups): Observable<any> {
    //return of(null);
    //console.log("===================================== GetLocalizedResourceGroups", groups)
    return this.restClient
      .post(`StringResource/GetLocalizedResourceGroups/`, groups)
      .pipe(
        //convert lower case property names to Upper case
        map((data) => GeneralUtilities.toUpperCase(data))
      );
  }
}
